// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link, Typography } from '@material-ui/core';
import React from 'react';
import { ArrowBackIcon } from '../../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';

const CustomModalHeader = ({ headerText, arrowAction, center, styles, ariaLabel, id }) => {
    return (
        <div className={styles.headerModal}>
            {!center && (
                <div
                    aria-hidden={center ? 'true' : undefined}
                    role={center ? 'presentation' : undefined}
                >
                    {arrowAction !== undefined && (
                        <Link
                            component='button'
                            type='button'
                            aria-label='Back to dashboard'
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === '') {
                                    e.preventDefault();
                                    arrowAction();
                                }
                            }}
                            onClick={arrowAction}
                        >
                            <ArrowBackIcon
                                className={'modal-header-back-icon'}
                                aria-label='Back to dashboard'
                            />
                        </Link>
                    )}
                </div>
            )}

            <div className='modal-header-text'>
                <Typography
                    role='heading'
                    aria-level={2}
                    component='h2'
                    variant='h2'
                    style={center ? { textAlign: 'center', width: '100%' } : {}}
                    id={id}
                    // tabIndex={-1}
                >
                    {headerText}
                </Typography>

                <div className='modal-header-line'></div>
            </div>
        </div>
    );
};

export default CustomModalHeader;
